import { render, staticRenderFns } from "./rePassword.vue?vue&type=template&id=22dce4b8&scoped=true"
import script from "./rePassword.vue?vue&type=script&lang=js"
export * from "./rePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dce4b8",
  null
  
)

export default component.exports